import Dinero, { Currency } from 'dinero.js';
import { CartItem } from '../../../../clients/customer-api/cart/cart';
import { LineItem, ProductLineItem } from '../../../../clients/quipli-service/financials/financials';
import { OrderType } from '../../../../clients/quipli-service/order/order';
import { TaxBreakdown } from '../../../../clients/quipli-service/tax/tax';
import { Location } from '../../../../clients/quipli-service/location/location';

export const displayPriceLabel = (
  item: CartItem,
  taxInclusive: boolean,
  location: Location,
  taxLabel: string,
  lineItem?: LineItem,
  taxBreakdown?: TaxBreakdown[],
) => {
  const productTax =
    taxBreakdown?.reduce((total, jurisdiction) => {
      return total.add(
        jurisdiction.itemizedBreakdown?.find(
          (_) => _.type === 'Product' && (_.contractLineItem as ProductLineItem)?.id == item.id,
        )?.tax || Dinero({ amount: 0, currency: location.currency as Currency }),
      );
    }, Dinero({ amount: 0, currency: location.currency as Currency })) ??
    Dinero({ amount: 0, currency: location.currency as Currency });
  const taxMessage = productTax.isZero() ? ` no ${taxLabel} incl.` : ` incl. ${taxLabel}`;
  switch (item.type) {
    case OrderType.Rental:
      return item.product.hidePrices
        ? 'Contact for pricing'
        : taxInclusive
        ? `${lineItem?.amount.add(productTax).toFormat() ?? '-'} ${taxMessage}`
        : lineItem?.amount.toFormat();
    case OrderType.Sale:
      return item.product.hideSalePrices
        ? 'Contact for pricing'
        : taxInclusive
        ? `${lineItem?.amount.add(productTax).toFormat() ?? '-'} ${taxMessage}`
        : lineItem?.amount.toFormat();
  }
};
